import styled from 'styled-components'

export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: fit-content;
  flex: 1;
  height: 100%;

  #layout-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100% !important;
    height: 100%;
    overflow: hidden;
  }

  #content-row {
    flex: 1;
  }

  .content-scrollable {
    // height: inherit;
    width: 100%;
  }
`
export const LayoutContainer = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: wrap;
  flex: 1;
  padding: 10px 10px;
  width: 100%;
  box-sizing: border-box;
  overflow: scroll;
`
